import { useState, useEffect, useMemo } from 'react';
import throttle from 'lodash.throttle';

import { hasWindow } from '../utils/window';

export default function useLayoutChange(wait = 100) {
  const [width, setWidth] = useState(hasWindow ? window.innerWidth : 1200);
  const [height, setHeight] = useState(hasWindow ? window.innerHeight : 768);

  useEffect(() => {
    const handleResize = throttle(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerWidth);
    }, wait);
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [wait]);

  return useMemo(() => [width, height], [width, height]);
}
